import 'babel-polyfill';
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import Notifications from 'vue-notification';

import router from './router';
import App from './App.vue';
import store from './store';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../public/assets/css/all.min.css';
import '../public/assets/css/hamburgers.min.css';
import '../public/assets/css/custom.css';
import moment from 'moment';
import VueGtm from '@gtm-support/vue2-gtm';

const hostname = window.location.hostname;

let config = {};

if (hostname === "www.liabilityinsuranceapps.com") {
  config = {
    siteName: "Liability Insurance Apps",
  };
} else {
  config = {
    siteName: "OREP Portal",
  };
}
document.title = config.siteName;

// Make config globally available
Vue.prototype.$config = config;

Vue.config.productionTip = false;
store.dispatch('initializeConfig');  // Call the action to set the hostname and other config

Vue.use(VeeValidate);
Vue.use(Notifications);
Vue.use(VueGtm, {
  id: 'GTM-NKCFRPX', // Replace this with your
  appName: config.siteName, // Dynamic app name
  pageTrackerScreenviewEnabled: true,
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY');
  }
});

const dictionary = {
  en: {
    messages: {
      numeric: () => 'ERROR: NUMERIC VALUES ONLY'
    }
  }
};

Validator.localize(dictionary);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');


